import React, { useEffect, useRef } from 'react'
import "../Landing.css"
import Footer from '../components/Footer'
import { ImWhatsapp } from 'react-icons/im'
import { FiInstagram } from 'react-icons/fi'
import Navbar from '../components/Navbar'
import HomeCollections from '../components/ColeccionesLanding'
import HomeAuthority from '../components/AutoridadLanding'
import  HomeBestSellers from '../components/BestSellersLanding'
import  AvancusInstitucional from '../components/AvancusInstitucional'
import { Link } from "react-router-dom";
import allProducts from "../catalogo/allProducts";

/* 🎯 Flujo ideal

Hero
↓
Autoridad
↓
Colecciones principales
↓
Más vendidos
↓
Footer

Eso es una landing sólida. */

function Landing() {

  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.currentTime = 6.5; // arranca en segundo 6
      video.play().catch(() => {});
    }
  }, []);

  return (
    <>
      <Navbar/>
      <div className='home'>
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        >
          <source src={"MOMENTUM.mp4"} type="video/mp4" />
        </video>

        <div className='hero-content'>
          <h1 className="hero-title">
            EQUIPAMIENTO
            <span>DE COMPETENCIA</span>
          </h1>

          <p className="hero-subtitle">
            Importador oficial de marcas internacionales
            para atletas de alto rendimiento en Argentina.
          </p>

          <Link to="/colecciones" className="hero-button">
            EQUIPATE AHORA
          </Link>
        </div>


        <div className='iconos'>
          <a href="https://instagram.com/liftingstore.arg/" rel="noreferrer" target="_blank">
            <FiInstagram/>
          </a>
          <a target='blank' href="https://wa.link/45a22m">
            <ImWhatsapp/>
          </a>
        </div>
      </div>
      <HomeAuthority/>
        <HomeCollections/>
        <AvancusInstitucional/>
        <HomeBestSellers  products={allProducts}  />

      <Footer/>
    </>
  );
}

export default Landing;
